import { template as template_d22d847dd5d94bed819c31737d589734 } from "@ember/template-compiler";
import { AVAILABLE_NIGHTS_PARAM, AVAILABLE_WEEKENDS_PARAM, FREE_CONSULTATION_PARAM, IN_PERSON_PARAM, MORE_FILTERS_EXTENDED_AVAILABILITY_OPTIONS, MORE_FILTERS_SESSION_TYPE_OPTIONS, buildMoreFiltersBooleanOptionRows } from 'client-portal/utils/clinicianSearch/more-filters-boolean-options';
import { buildTreatmentTypeFacetOptions } from 'client-portal/utils/clinicianSearch/treatment-type-facet-options';
import { facetOptionDisabled } from 'client-portal/utils/clinicianSearch/facet-catalog';
import { facetOptionSlug } from 'client-portal/utils/clinicianSearch/facet-option-slug';
import { filterClinicians } from 'client-portal/utils/clinicianSearch/send-all-catalog';
import { fn } from '@ember/helper';
import { parseBooleanQueryParam, parseTrimmedString } from 'client-portal/utils/clinicianSearch/comma-query-param';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import RequestClinicianSearchFiltersFilterCheckboxLine from '../filters/filter-checkbox-line';
import RequestClinicianSearchFiltersFilterRadioLine from '../filters/filter-radio-line';
import RequestClinicianSearchFiltersPanel from '../filters/panel';
import styles from './more-filters.module.scss';
import t from 'ember-intl/helpers/t';
const RADIO_NAME = 'clinician-search-treatment-type-filter';
export default class RequestClinicianSearchFacetFiltersMoreFilters extends Component {
    @service
    intl;
    @service
    clinicianSearch;
    radioName = RADIO_NAME;
    @tracked
    draftTreatmentType = '';
    @tracked
    draftAvailableNights = false;
    @tracked
    draftAvailableWeekends = false;
    @tracked
    draftInPerson = false;
    @tracked
    draftFreeConsultation = false;
    @tracked
    options = [];
    @tracked
    extendedAvailabilityRows = [];
    @tracked
    sessionTypeRows = [];
    @tracked
    loadFailed = false;
    @tracked
    isLoadingOptions = true;
    constructor(){
        super(...arguments);
        let query = this.clinicianSearch.query;
        this.draftTreatmentType = String(query.treatmentType ?? '').trim();
        this.draftAvailableNights = parseBooleanQueryParam(query[AVAILABLE_NIGHTS_PARAM]);
        this.draftAvailableWeekends = parseBooleanQueryParam(query[AVAILABLE_WEEKENDS_PARAM]);
        this.draftInPerson = parseBooleanQueryParam(query[IN_PERSON_PARAM]);
        this.draftFreeConsultation = parseBooleanQueryParam(query[FREE_CONSULTATION_PARAM]);
    }
    get panelLoading() {
        return this.isLoadingOptions || this.clinicianSearch.sendAll.isLoading;
    }
    get moreFiltersLoadingAriaLabel() {
        if (this.clinicianSearch.sendAll.isLoading) {
            return this.intl.t('booking.clinicianSearch.filterDetail.filterOptionsLoading');
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.treatmentTypeOptionsLoading');
    }
    refreshBooleanOptionRows = (routeParams)=>{
        let rows = buildMoreFiltersBooleanOptionRows(this.clinicianSearch.sendAll.records, routeParams, filterClinicians);
        let rowByParam = Object.fromEntries(rows.map((row)=>[
                row.param,
                row
            ]));
        this.extendedAvailabilityRows = MORE_FILTERS_EXTENDED_AVAILABILITY_OPTIONS.map((spec)=>rowByParam[spec.param]);
        this.sessionTypeRows = MORE_FILTERS_SESSION_TYPE_OPTIONS.map((spec)=>rowByParam[spec.param]);
    };
    refreshOptions = ()=>{
        let routeParams = this.clinicianSearch.query.toRouteParams();
        this.refreshBooleanOptionRows(routeParams);
        this.loadFailed = false;
        this.isLoadingOptions = true;
        try {
            let treatmentTypeRouteParams = {
                ...routeParams,
                treatmentType: null
            };
            let meta = this.clinicianSearch.sendAll.buildFacetsMeta(treatmentTypeRouteParams);
            this.options = buildTreatmentTypeFacetOptions(this.clinicianSearch.sendAll.records, meta?.facets?.treatmentTypes ?? []);
        } catch  {
            this.loadFailed = true;
            this.options = [];
        } finally{
            this.isLoadingOptions = false;
        }
    };
    isOptionSelected = (opt)=>this.draftTreatmentType.toLowerCase() === String(opt.key ?? '').toLowerCase();
    isBooleanOptionSelected = (row)=>{
        switch(row.param){
            case AVAILABLE_NIGHTS_PARAM:
                return this.draftAvailableNights;
            case AVAILABLE_WEEKENDS_PARAM:
                return this.draftAvailableWeekends;
            case IN_PERSON_PARAM:
                return this.draftInPerson;
            case FREE_CONSULTATION_PARAM:
                return this.draftFreeConsultation;
            default:
                return false;
        }
    };
    optionDisabled = (opt)=>facetOptionDisabled(opt.docCount, this.isOptionSelected(opt));
    booleanOptionDisabled = (row)=>facetOptionDisabled(row.docCount, this.isBooleanOptionSelected(row));
    treatmentTypeOptionRowTitle = (opt)=>{
        if (!this.optionDisabled(opt)) {
            return '';
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.disabledFilterOption');
    };
    booleanOptionRowTitle = (row)=>{
        if (!this.booleanOptionDisabled(row)) {
            return '';
        }
        return this.intl.t('booking.clinicianSearch.filterDetail.disabledFilterOption');
    };
    optionId = (opt)=>facetOptionSlug(opt.key);
    selectTreatmentType = (opt, event)=>{
        if (!event.target.checked || !opt.key) {
            return;
        }
        this.draftTreatmentType = opt.key;
    };
    toggleBooleanOption = (row, event)=>{
        switch(row.param){
            case AVAILABLE_NIGHTS_PARAM:
                this.draftAvailableNights = event.target.checked;
                break;
            case AVAILABLE_WEEKENDS_PARAM:
                this.draftAvailableWeekends = event.target.checked;
                break;
            case IN_PERSON_PARAM:
                this.draftInPerson = event.target.checked;
                break;
            case FREE_CONSULTATION_PARAM:
                this.draftFreeConsultation = event.target.checked;
                break;
        }
    };
    apply = ()=>{
        this.clinicianSearch.query.applySearchFilter({
            treatmentType: parseTrimmedString(this.draftTreatmentType) || null,
            [AVAILABLE_NIGHTS_PARAM]: this.draftAvailableNights ? true : null,
            [AVAILABLE_WEEKENDS_PARAM]: this.draftAvailableWeekends ? true : null,
            [IN_PERSON_PARAM]: this.draftInPerson ? true : null,
            [FREE_CONSULTATION_PARAM]: this.draftFreeConsultation ? true : null
        });
        this.clinicianSearch.mobile.backFromDetail();
    };
    static{
        template_d22d847dd5d94bed819c31737d589734(`
    <RequestClinicianSearchFiltersPanel
      @applyDisabled={{false}}
      @class={{styles.component}}
      class="clinician-search-filter-more-filters-options"
      @facetKey="moreFilters"
      @isLoading={{this.panelLoading}}
      @loadingAriaLabel={{this.moreFiltersLoadingAriaLabel}}
      @onApply={{this.apply}}
      @onLoad={{this.refreshOptions}}
      data-test-clinician-search-filter-more-filters-options
    >
      <p class="filter-section-title">{{t
          "booking.clinicianSearch.filterDetail.moreFiltersFilterPanelTitle"
        }}</p>
      {{#if this.loadFailed}}
        <p class="error" data-test-clinician-search-filter-treatment-type-options-error>
          {{t "booking.clinicianSearch.filterDetail.treatmentTypeLoadError"}}
        </p>
      {{/if}}
      <div class="body">
        <div
          class="filter-group"
          role="group"
          aria-labelledby="clinician-search-more-filters-appointment-type-title"
          data-test-clinician-search-filter-treatment-type-options
        >
          <p
            class="filter-group-heading"
            id="clinician-search-more-filters-appointment-type-title"
          >{{t "booking.clinicianSearch.filterDetail.appointmentTypeHeading"}}</p>
          <ul class="filter-checkbox-list" role="list">
            {{#each this.options as |opt|}}
              <RequestClinicianSearchFiltersFilterRadioLine
                @kind="treatmentType"
                @optionId={{this.optionId opt}}
                @docCount={{opt.docCount}}
                @name={{this.radioName}}
                @value={{opt.key}}
                @checked={{this.isOptionSelected opt}}
                @disabled={{this.optionDisabled opt}}
                @title={{this.treatmentTypeOptionRowTitle opt}}
                @onChange={{fn this.selectTreatmentType opt}}
              >
                {{opt.label}}
              </RequestClinicianSearchFiltersFilterRadioLine>
            {{/each}}
          </ul>
        </div>

        <div
          class="filter-group"
          role="group"
          aria-labelledby="clinician-search-more-filters-extended-availability-title"
          data-test-clinician-search-filter-extended-availability-options
        >
          <p
            class="filter-group-heading"
            id="clinician-search-more-filters-extended-availability-title"
          >{{t "booking.clinicianSearch.filterDetail.extendedAvailabilityHeading"}}</p>
          <ul class="filter-checkbox-list" role="list">
            {{#each this.extendedAvailabilityRows as |row|}}
              <RequestClinicianSearchFiltersFilterCheckboxLine
                @kind={{row.kind}}
                @optionId={{row.optionId}}
                @docCount={{row.docCount}}
                @checked={{this.isBooleanOptionSelected row}}
                @disabled={{this.booleanOptionDisabled row}}
                @title={{this.booleanOptionRowTitle row}}
                @onChange={{fn this.toggleBooleanOption row}}
              >
                {{t row.labelKey}}
              </RequestClinicianSearchFiltersFilterCheckboxLine>
            {{/each}}
          </ul>
        </div>

        <div
          class="filter-group"
          role="group"
          aria-labelledby="clinician-search-more-filters-session-type-title"
          data-test-clinician-search-filter-session-type-options
        >
          <p class="filter-group-heading" id="clinician-search-more-filters-session-type-title">{{t
              "booking.clinicianSearch.filterDetail.sessionTypeHeading"
            }}</p>
          <ul class="filter-checkbox-list" role="list">
            {{#each this.sessionTypeRows as |row|}}
              <RequestClinicianSearchFiltersFilterCheckboxLine
                @kind={{row.kind}}
                @optionId={{row.optionId}}
                @docCount={{row.docCount}}
                @checked={{this.isBooleanOptionSelected row}}
                @disabled={{this.booleanOptionDisabled row}}
                @title={{this.booleanOptionRowTitle row}}
                @onChange={{fn this.toggleBooleanOption row}}
              >
                {{t row.labelKey}}
              </RequestClinicianSearchFiltersFilterCheckboxLine>
            {{/each}}
          </ul>
        </div>
      </div>
    </RequestClinicianSearchFiltersPanel>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
